import { createExtendedMesh, ExtendedMesh } from 'src/app/interfaces/shared/extendMesh';
// import * as THREE from "three";
import { Config } from "../../../interfaces/shared/config";

export class PointShape {
    geometry: THREE.BufferGeometry = new THREE.BufferGeometry();
    name: string = '';
    position: THREE.Vector3 = new THREE.Vector3();
    scale: number = 1;
    mesh: ExtendedMesh = createExtendedMesh();
    color: any;
    is2d: boolean = false;
    posOffset: any;

    constructor(options: { x: number | undefined; y: number | undefined; z: number | undefined; color: any; scale: number; }) {
        this.position = new THREE.Vector3(options.x, options.y, options.z);
        this.color = this.getColor(options.color);
        this.scale = options.scale || 1;
        this.createMesh();
    }

    getColor(color: string | number | string[]) {
        if (typeof color === "string" && color[0] === "#") {
            return Config.colorNames[color];
        } else {
            return color;
        }
    }

    createMesh() {
        try {
            let material = new THREE.MeshPhongMaterial({
                color: 0x000000
            });
            let sphere = new THREE.SphereGeometry(1, 4);
            // let buffer = new THREE.BufferGeometry().fromGeometry(sphere)
            let mesh = createExtendedMesh(sphere, material);

            this.mesh = mesh;
            this.mesh.position.set(this.position.x, this.position.y, this.position.z);
            this.mesh.name = this.name;
            this.mesh.scale.set(this.scale, this.scale, this.scale);

            this.mesh.updateMatrix();
        } catch (e) {
            console.error(e)
        }
    }
}